import React from 'react';
import ErrorBoundary from './ErrorBoundary';

/**
 * @deprecated Please use ErrorBoundary or withErrorBoundary from @fiverr-private/ui_utils instead.
 */
// eslint-disable-next-line react/display-name
const SafeComponent = (WrappedComponent, onError = Function.prototype) => (props) => (
    <ErrorBoundary onError={onError}>
        <WrappedComponent {...props}/>
    </ErrorBoundary>
);

export default SafeComponent;
